import React from 'react'
import { useTheme } from '@mui/material'

import Spacer from '../../../../atoms/Spacer'
import MediaViewerModal from '../../../ChatModals/MediaViewerModal'
import { DocumentDownload } from 'iconsax-react'

import useStyles from './styles'

const Other = ({ media, length, imgsLength, isYours }) => {
  const theme = useTheme()

  const [modalOpen, setModalOpen] = React.useState(false)

  const classes = useStyles({ length, imgsLength, isYours })

  const { filename } = media

  return (
    <>
      <div className={classes.root}>
        <div onClick={() => setModalOpen(true)} className={classes.link}>
          {filename}
        </div>

        <Spacer />

        <DocumentDownload size={theme.size.base} className={classes.icon} />
      </div>

      {modalOpen && (
        <MediaViewerModal
          file={modalOpen ? media : null}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  )
}

export default Other
